import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=7cfa76c5"
import script from "@/scripts/payment/paymentGateway.js?vue&type=script&lang=js&external"
export * from "@/scripts/payment/paymentGateway.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports